import { Link } from '@cian/ui-kit';
import { TAnswer } from 'shared/types/faq';

interface IRowProps {
  content: TAnswer;
}

export const Row: React.FC<IRowProps> = ({ content }) => {
  if (content.type === 'link') {
    return (
      <Link href={content.url} target="_blank" rel="noopener noreferrer">
        {content.value}
      </Link>
    );
  }

  if (content.type === 'list') {
    const List = content.style === 'bullet' ? 'ul' : 'ol';

    return (
      <List>
        {content.value.map((item, index) => (
          <li key={index}>{item.value}</li>
        ))}
      </List>
    );
  }

  return <span>{content.value}</span>;
};
